document.addEventListener("DOMContentLoaded", function () {

  const stickyBar = document.querySelector(".stickybar-subscribers");

  if (!stickyBar) return;

  window.addEventListener("scroll", function () {

    if (window.scrollY > 300) { // change scroll value
      stickyBar.classList.add("show-stickybar");
    } else {
      stickyBar.classList.remove("show-stickybar");
    }

  });

});


// 1. Get all containers using CSS.escape for the Tailwind slash
const tooltipContainers = document.querySelectorAll(`.${CSS.escape('group/tooltip')}`);
 
// 2. Only run if containers actually exist on the page
if (tooltipContainers.length > 0) {
  tooltipContainers.forEach(container => {
    container.addEventListener('mouseenter', () => {
      // 3. Check if the specific tooltip span exists inside this container
      const tooltip = container.querySelector('[role="tooltip"]');
      if (tooltip) {
        // Reset to default for calculation
        tooltip.style.left = '50%';
        tooltip.style.right = 'auto';
        tooltip.style.top = 'auto';
        tooltip.style.bottom = '100%';
        tooltip.style.transform = 'translateX(-50%)';
 
        const rect = tooltip.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
 
        // Check Left Edge
        if (rect.left < 0) {
          tooltip.style.left = '0';
          tooltip.style.transform = 'translateX(0)';
        } 
        // Check Right Edge
        else if (rect.right > viewportWidth) {
          tooltip.style.left = 'auto';
          tooltip.style.right = '0';
          tooltip.style.transform = 'translateX(0)';
        }
 
        // Check Top Edge
        if (rect.top < 0) {
          tooltip.style.bottom = 'auto';
          tooltip.style.top = '100%';
          tooltip.style.marginTop = '8px';
        } else {
          tooltip.style.marginTop = '0';
        }
      }
    });
  });
}